












































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { AuthApi } from "@/core/auth";
import store from "@/store";
import * as C from "@/common";
import VueRecaptcha from "vue-recaptcha";

@Component({
	components: {
		VueRecaptcha,
	},
})
export default class UserCard extends Vue {
	private get Rules(): { [name: string]: (v: string) => true | string } {
		return {
			required: v => !!v || this.$tc("auth_rule_required"),
			min: v => v.length >= 8 || "Min 8 characters",
			email: v => UserCard.MAIL_REGEX.test(v) || this.$tc("auth_rule_email"),
			passwordMatch: v => v === this.password || this.$tc("auth_rule_passwordMatch"),
			passwordComplexity: v => this.mode !== "register" || (v
				&& v.length >= 8
				&& (  (UserCard.PASSWORD_REGEX_LOWERCASE.test(v) ? 1 : 0)
					+ (UserCard.PASSWORD_REGEX_UPPERCASE.test(v) ? 1 : 0)
					+ (UserCard.PASSWORD_REGEX_NUMBER.test(v) ? 1 : 0)
					+ (UserCard.PASSWORD_REGEX_SPECIAL.test(v) ? 1 : 0)
					) >= 3
				) || this.$tc("auth_rule_passwordComplexity"),
		};
	}

	private get User() { return this.$store.state.user as C.IUserInfo; }
	private get UserAvatar() { const u = this.User; return `/img/profile/ProfilePicture_${(u ? u.orig : "null")}.png`; }
	private get UserTitle() { return this.$tc(`profile_nouser_title${this.User ? "_logout" : ""}`); }
	private get UserSubTitle() { const u = this.User; return u ? u.nickname : this.$tc("profile_nouser_subtitle"); }

	private static readonly MAIL_REGEX = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
	private static readonly PASSWORD_REGEX_LOWERCASE = /[a-zöäü]/;
	private static readonly PASSWORD_REGEX_UPPERCASE = /[A-ZÖÄÜ]/;
	private static readonly PASSWORD_REGEX_NUMBER = /[0-9]/;
	private static readonly PASSWORD_REGEX_SPECIAL = /[\!\"\§\$\%\&\/\(\)\=\?\ß\#\@\µ\-\.\,\+\*\'\?\\\[\]\{\}\_\€\~]/;


	public authDialog: boolean = false;
	public isReset: boolean = false;
	public isNewUser: boolean = false;
	public mode: "login" | "register" | "reset" = "login";
	public authShowPassword: boolean = false;
	public username: string = "";
	public password: string = "";
	public passwordRepeat: string = "";
	public captcha: string | null = null;
	public errors: string[] = [];
	public messages: string[] = [];
	// private readonly recaptchaApiKey = "6Lch08cUAAAAAAxqeNDl6C-q3PK16azf6JrA39Vh"; // localhost
	private readonly recaptchaApiKey = "6LcgPTUUAAAAANbq_5V4-Wh2pxTy5CUXQ6iFKJwS";
	private auth: AuthApi = new AuthApi();

	private openAuthDialog() {
		if (this.User) {
			this.$store.commit("signout");
			setTimeout(() => {
				window.location.reload();
			}, 250);
		} else
			this.authDialog = true;
	}
	private cancelAuth() {
		this.authDialog = false;
		this.username = "";
		this.password = "";
		this.$router.push({ name: "home"});
	}
	private async authenticate() {
		this.errors = [];
		this.messages = [];
		switch (this.mode) {
			case "login":
				try {
					const token = await this.auth.authenticate({
						u: this.username,
						p: this.password,
					});

					if (token) {
						this.authDialog = false;
						this.username = "";
						this.password = "";
					} else
						this.errors.push(this.$tc("auth_fail"));
				} catch (error) {
					this.errors.push(this.$tc("auth_fail"));
					if (error && error.message)
						this.errors.push(error.message);
				}
				this.$router.push({ name: "registration" });
				return;
			case "register":
				if (!this.captcha)
					this.errors.push(this.$tc("captcha_missing"));
				else
					try {
						await this.auth.register({
							c: this.captcha,
							u: this.username,
							p: this.password,
						});
						this.messages.push(this.$tc("auth_register_confirm_mail"));
					} catch (error) {
						this.errors.push(this.$tc("register_fail"));
						if (error && error.message)
							this.errors.push(error.message);
					}
				return;
			case "reset":
				if (!this.captcha)
					this.errors.push(this.$tc("captcha_missing"));
				else
					try {
						await this.auth.reset({
							c: this.captcha,
							u: this.username,
						});
					} catch (error) {
						this.errors.push(this.$tc("reset_fail"));
						if (error && error.message)
							this.errors.push(error.message);
					}
				return;
			default:
				break;
		}
	}
	@Watch("$route")
	private onRouteChanged() {
		if (this.$route.meta.isLogin === true) {
			setTimeout(() => {
				this.authDialog = true;
			}, 500);
		}

	}

	private onRecaptchaVerify(response: string) {
		this.captcha = response || null;
	}
	private onRecaptchaExpired() {
		this.captcha = null;
	}
}
